export async function getTestData(queryName: string): Promise<any> {
  console.log(`Loading mock data (${queryName}) ...`)
  const fs = require("fs")
  try {
    return JSON.parse(fs.readFileSync(`src/data/mock/${queryName}.json`))
  } catch (e) {
    console.log(`Failed to load mock data (${queryName}):`, e)
    throw e
  }
}
